import ReportContent from "./Content";
import React from "react";

const ReportRerun = () => {
  return (
    <>
      <ReportContent />
    </>
  )
}

export default ReportRerun;
